// extracted by mini-css-extract-plugin
export default {"noData":"no-data_noData__b9QYR"};